/*
* Velvet Theme
*
* Use this file to add custom Javascript to Velvet.  Keeping your custom
* Javascript in this fill will make it easier to update Velvet. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line






  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

(function () {
  /** Seletores básicos */
  const GROUP_SELECTOR = '[data-swatches-container]';
  const LEGEND_SELECTOR = '[data-swatches-label]';
  const RADIO_SELECTOR = 'input[type="radio"]';

  /**
   * Localiza o <label> associado ao radio e devolve o que estiver em data-swatch
   */
  function getColorName(input) {
    const label = document.querySelector(`label[for="${input.id}"][data-swatch]`);
    return label ? label.dataset.swatch : input.value;
  }

  /**
   * Atualiza o texto “COR: Nome” no legend do grupo
   */
  function updateLegend(input) {
    const group = input.closest(GROUP_SELECTOR);
    if (!group) return;

    const legend = group.querySelector(LEGEND_SELECTOR);
    if (!legend) return;

    const base = legend.querySelector('.radio__legend__label');
    if (!base) return;

    base.textContent = `COR: ${getColorName(input)}`;
  }

  /* --- Inicializa na primeira renderização --- */
  function init() {
    // radios que já vêm marcados no HTML
    document.querySelectorAll(`${GROUP_SELECTOR} ${RADIO_SELECTOR}:checked`)
            .forEach(updateLegend);
  }

  /* --- Ouvintes --- */
  // troca feita pelo usuário
  document.addEventListener('change', (e) => {
    const input = e.target;
    if (input.matches(`${GROUP_SELECTOR} ${RADIO_SELECTOR}`) && input.checked) {
      updateLegend(input);
    }
  });

  // alguns temas disparam variant:change via JS
  document.addEventListener('variant:change', init);

  // garante que rode mesmo se o script carregar antes do DOM estar pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();